/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loc-label[_ngcontent-%COMP%]{display:flex;align-items:center;flex-wrap:wrap;padding-left:6px;padding-right:6px}.loc-label[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-left:6px;margin-right:6px}.loc-status[_ngcontent-%COMP%]{margin-left:6px}.loc-city-state[_ngcontent-%COMP%]{font-size:15px}"];
export { styles as styles };
